import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

// Back-compat option shape so existing call sites keep working.
export type ToastAppearanceOptions = {
  autoDismiss?: boolean;
  autoDismissTimeout?: number;
};

type Toasts = {
  addError: (e: React.ReactNode, options?: ToastAppearanceOptions) => void;
  addSuccess: (e: React.ReactNode, options?: ToastAppearanceOptions) => void;
  addWarning: (e: React.ReactNode, options?: ToastAppearanceOptions) => void;
};

const DEFAULT_AUTO_CLOSE_MS = 5000;

const toOptions = (options?: ToastAppearanceOptions): ToastOptions => ({
  autoClose:
    options?.autoDismiss === false
      ? false
      : options?.autoDismissTimeout ?? DEFAULT_AUTO_CLOSE_MS,
});

export const useToasts = (): Toasts => {
  const addError = React.useCallback(
    (e: React.ReactNode, options?: ToastAppearanceOptions) =>
      toast.error(e, toOptions(options)),
    [],
  );

  const addSuccess = React.useCallback(
    (e: React.ReactNode, options?: ToastAppearanceOptions) =>
      toast.success(e, toOptions(options)),
    [],
  );

  const addWarning = React.useCallback(
    (e: React.ReactNode, options?: ToastAppearanceOptions) =>
      toast.warning(e, toOptions(options)),
    [],
  );

  return { addError, addSuccess, addWarning };
};
